import { useCallback, useEffect, useState } from "react";

export const useTagButton = (children, setMyTags, myTags) => {
  const [isOn, setIsOn] = useState(true);

  const handleTagToggle = () => {
    let myTagIndex = myTags.findIndex((el) => el === children);
    if (myTagIndex < 0) {
      setMyTags([...myTags, children]);
    } else {
      setMyTags(myTags.filter((tag) => tag !== children));
    }
  };

  const checkIsOn = useCallback(() => {
    let myTagIndex = myTags.findIndex((el) => el === children);
    if (myTagIndex < 0) {
      setIsOn(false);
    } else {
      setIsOn(true);
    }
  }, [children, myTags]);

  useEffect(() => {
    checkIsOn();
  }, [checkIsOn]);

  return { handleTagToggle, isOn };
};
